import { Flex, Text } from "@radix-ui/themes";
import { motion } from "framer-motion";
import { useAppSelector } from "../../hooks/hooks";
import { useIES } from "../../hooks/useIES";

export const FullPageLoader = () => {
  const { IES } = useIES();
  const isAvailable = useAppSelector(
    (state) => state.loaderController.isAvailable
  );

  if (!isAvailable) return null;

  return (
    <Flex
      align="center"
      justify="center"
      role="status"
      aria-live="polite"
      aria-label="A carregar"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "var(--color-overlay)",
        backdropFilter: "blur(6px)",
      }}
    >
      <Flex direction="column" align="center" justify="center" gap="4">
        <motion.img
          src={`${IES.LOGO}`}
          alt=""
          style={{
            width: "88px",
            height: "88px",
            objectFit: "contain",
            borderRadius: "var(--radius-4)",
            padding: "var(--space-3)",
            backgroundColor: "var(--color-panel-solid)",
            boxShadow: "var(--shadow-5)",
          }}
          animate={{ scale: [1, 1.06, 1], opacity: [0.75, 1, 0.75] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Barra de progresso indeterminada, alinhada com o accent color do tema */}
        <div
          style={{
            width: "140px",
            height: "3px",
            borderRadius: "var(--radius-6)",
            backgroundColor: "var(--gray-5)",
            overflow: "hidden",
          }}
        >
          <motion.div
            style={{
              width: "40%",
              height: "100%",
              borderRadius: "var(--radius-6)",
              backgroundColor: "var(--accent-9)",
            }}
            animate={{ x: ["-100%", "250%"] }}
            transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>

        <Text size="2" weight="medium" color="gray">
          A carregar…
        </Text>
      </Flex>
    </Flex>
  );
};
